export const repairPriorityDropdown = [
    { value: "high", label: "High" },
    { value: "medium", label: "Medium" },
    { value: "low", label: "Low" }
];

export const maintenanceTypesDropdown = [
    { value: "scheduled", label: "Scheduled" },
    { value: "unscheduled", label: "Unscheduled" }
];

export const priorityOptions = [
    { value: "low", label: "Low" },
    { value: "medium", label: "Medium" },
    { value: "high", label: "High" }
];

export const repairPriorityOptions = [
    { value: "scheduled", label: "Scheduled" },
    { value: "Unscheduled", label: "Unscheduled" },
];

export const statusOptions = [
    { value: "open", label: "Open" },
    { value: "in_progress", label: "In Progress" },
    { value: "resolved", label: "Resolved" },
    { value: "completed", label: "Completed" },
    { value: "closed", label: "Closed" }
];

export const workOrderStatusFilterOptions = [
    { value: "pending", label: "Pending" },
    { value: "in_progress", label: "In Progress" },
    { value: "approved", label: "Approved" },
    { value: "completed", label: "Completed" },
    { value: "closed", label: "Closed" },
];

export const approvalStatusOptions = [
    { value: "approved", label: "Approved" },
    { value: "in_progress", label: "In Progress" },
    { value: "completed", label: "Completed" },
]

export const serviceStatusOptions = [
    { value: "pending", label: "Pending" },
    { value: "in_progress", label: "In Progress" },
    { value: "completed", label: "Completed" },
]

export const workOrderStatusOptions = [
    { value: "open", label: "Open" },
    { value: "pending", label: "Pending" },
    { value: "completed", label: "Completed" },
    { value: "approved", label: "Approved" },
    { value: "rejected", label: "Rejected" },
    { value: "closed", label: "Closed" },
];

export const uploadTypeOptions = [
    { value: 'maintenance', label: 'Maintenance' },
    { value: 'tyres', label: 'Tyres' },
];

export const workStatusOptions = [
    { value: "created", label: "Created" },
    { value: "open", label: "Open" },
    { value: "pending", label: "Pending" },
    { value: "completed", label: "Completed" }
];

export const filterDropdown = [
    {value: "pending", label: "Pending"},
    {value: "approved", label: "Approved"},
    {value: "rejected", label: "Rejected"},
]